<style scoped>

.query-form {
    margin-top: 40px;
}
.row-ruleForm {
    display: flex;
    flex-direction: row;
}
</style>

<template>
    <div>
        <h1>发送系统邮件</h1>
        <div class="query-form">
            <el-form class="demo-ruleForm">
                <el-form-item label="邮件标题" label-width="80px" prop="title">
                    <el-input type="text" v-model="addSystemMail.title" auto-complete="off" placeholder="请输入邮件标题" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="邮件内容" label-width="80px" prop="content">
                    <el-input type="text" v-model="addSystemMail.content" auto-complete="off" placeholder="请输入邮件内容" style="width:300px;"></el-input>
                </el-form-item>
                
                <el-form-item label-width="80px">
                    <el-button class="button-width" type="danger" @click="reset()">重置</el-button>
                    <el-button class="button-width" type="primary" @click="submitSystemMail()">发送邮件</el-button>
                </el-form-item>
            </el-form>
                
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import {addSystemMail} from '@/request/api';
export default {
    data() {
        return {
            addSystemMail: {
                title: '',
                content: '',
            },
        };
    },
    methods: {
        reset() {
            this.addSystemMail = {
                title: '',
                content: ''
            }
        },
        submitSystemMail() {
            console.log(this.addSystemMail)
            if (this.addSystemMail.title == '') {
                this.$message.error('请输入邮件标题');
                return;
            }
            if (this.addSystemMail.content == '') {
                this.$message.error('请输入邮件内容');
                return;
            }
            addSystemMail(
                this.addSystemMail
            ).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("发送成功");
                    this.reset();
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/mail/systemMail.vue